import { render } from "./tab-2.vue?vue&type=template&id=c96f7018"
import script from "./tab-2.vue?vue&type=script&lang=js"
export * from "./tab-2.vue?vue&type=script&lang=js"
script.render = render

export default script